module.exports = __webpack_public_path__ + "img/hve.c319c547.png";